import type { BrowserEngineArtifact } from "@chessla/shared";
import { apiClient } from "@/shared/api/client";
import type { BrowserEngineArtifactStoreResult } from "./browser-engine.contract";

export const storeBrowserEngineArtifact = (
  artifact: BrowserEngineArtifact,
): Promise<BrowserEngineArtifactStoreResult> =>
  apiClient<BrowserEngineArtifactStoreResult>("/coach/engine-evidence", {
    method: "POST",
    body: JSON.stringify(artifact),
  });
